module.exports = __webpack_public_path__ + "img/co2_blue.9edf4648.svg";